import styled from 'styled-components';

const Definition = styled.div`
   font-size: 0.8em;
   margin: 25px 0px 3px 0px;
   font-weight: bold;
`;

export default Definition;
